  export default [
    {
      id: 'ASCENDING',
      text: 'Crescente',
      value: 'asc',
    },
    {
      id: 'DESCENDING',
      text: 'Decrescente',
      value: 'desc',
    },
  ];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quoting-return/enum/EnumSortDirection.js